import { useState } from "react";
import { Form, InputGroup, Modal } from "react-bootstrap";
import { BiSearch } from "react-icons/bi";

import { casinoGamesList } from "../../lib/data/casinoGames.data";
import { sliderGames } from "./renderHomePageContent";
const GamesSearchModal = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [filteredData, setFilteredData] = useState(null);
  const [searchText, setSearchText] = useState(false);
  const targetProviders = [
    "ezugi",
    "evolution",
    "worldcasino",
    "supernowa",
    "NetEnt",
    "RedTiger",
    "qtech",
    "spribe",
    "Kingmaker",
    "xpg",
    "vivo",
  ];

  const allGames = Object.values(casinoGamesList)
    .map((item) => Object.values(item))
    .map((item) => Object.values(item))
    .flat();

  const gamesByProvider = targetProviders.reduce((acc, provider) => {
    acc[provider] = allGames
      .filter((game) => game.provider === provider)
      .slice(0, 9);
    return acc;
  }, {});
  const data = [...Object.values(gamesByProvider).flat(), ...sliderGames];

  const handleSearch = (e) => {
    if (e) {
      setSearchText(true);

      let filteredValue = Object.values(data)?.filter((item) => {
        return (
          item?.name && item?.name.toLowerCase().indexOf(e?.toLowerCase()) > -1
        );
      });
      setFilteredData(filteredValue);
    } else {
      setSearchText(false);
    }
  };

  return (
    <div>
      <div className="searchGames" onClick={handleShow}>
        <BiSearch />
        <p className="d-none d-md-block" style={{ whiteSpace: "nowrap" }}>
          Search Games
        </p>
      </div>

      <div>
        <Modal show={show} onHide={handleClose} className="searchGames1">
          <Modal.Header closeButton>
            <Modal.Title style={{ color: "#000" }}>
              Search For Games
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {" "}
            <InputGroup className="mb-3 search-icon">
              <Form.Control
                placeholder="Search"
                aria-label="Text input with dropdown button"
                type="search"
                onChange={(e) => handleSearch(e.target.value)}
                autoFocus
                className="searchInput"
              />
            </InputGroup>
            <div className="GamesShow">
              {Array.isArray(filteredData) &&
                filteredData.map((item) => (
                  <div className="displayGames">
                    <a href={item.href}>
                      <img src={item?.imgUrl || item?.img} />
                    </a>
                  </div>
                ))}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default GamesSearchModal;
